import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { createBookApi } from '../../utils/api';

const GENRES = ['Fiction','Non-Fiction','Mystery','Romance','Sci-Fi','Fantasy','Biography','Self-Help','Horror','Thriller','History','Other'];

export default function AdminAddBook() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ title:'', description:'', genre:'Fiction', price:'', author:'', tags:'' });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault(); setError(''); setBusy(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v])=>fd.append(k,v));
      if (file) fd.append('coverImage', file);
      await createBookApi(fd);
      navigate('/admin/books');
    } catch(err) { setError(err.response?.data?.message||'Failed'); }
    finally { setBusy(false); }
  };

  return (
    <AdminLayout title="Add New Book">
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'32px', maxWidth:900 }}>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          <div style={{ display:'grid', gridTemplateColumns:'200px 1fr', gap:40 }}>
            {/* Cover */}
            <div>
              <label style={{ display:'block', cursor:'pointer', border:'2px dashed var(--border2)', borderRadius:12, overflow:'hidden', transition:'border-color 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.borderColor='var(--gold)'}
                onMouseLeave={e=>e.currentTarget.style.borderColor='var(--border2)'}>
                {preview
                  ? <img src={preview} alt="" style={{width:'100%',display:'block',aspectRatio:'2/3',objectFit:'cover'}}/>
                  : <div style={{aspectRatio:'2/3',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:10,background:'var(--bg3)'}}>
                      <span style={{fontSize:'2.5rem'}}>🖼️</span>
                      <span style={{color:'var(--text3)',fontSize:'0.8rem',textAlign:'center',padding:'0 12px'}}>Click to upload cover</span>
                    </div>}
                <input type="file" accept="image/*" style={{display:'none'}} onChange={e=>{const f=e.target.files[0];if(f){setFile(f);setPreview(URL.createObjectURL(f));}}} />
              </label>
              {preview && <button type="button" onClick={()=>{setFile(null);setPreview(null);}} style={{marginTop:8,width:'100%',background:'none',border:'1px solid var(--accent)',borderRadius:8,padding:'6px',color:'var(--accent)',cursor:'pointer',fontSize:'0.78rem',fontFamily:'var(--font-b)'}}>Remove</button>}
            </div>

            {/* Fields */}
            <div>
              <div className="form-group">
                <label>Book Title *</label>
                <input className="form-control" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} placeholder="Enter title" required/>
              </div>
              <div className="form-group">
                <label>Author Name</label>
                <input className="form-control" value={form.author} onChange={e=>setForm({...form,author:e.target.value})} placeholder="Your name or pen name"/>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
                <div className="form-group">
                  <label>Genre *</label>
                  <select className="form-control" value={form.genre} onChange={e=>setForm({...form,genre:e.target.value})}>
                    {GENRES.map(g=><option key={g}>{g}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Price ₹ (0 = Free)</label>
                  <input className="form-control" type="number" min="0" value={form.price} onChange={e=>setForm({...form,price:e.target.value})} placeholder="0"/>
                </div>
              </div>
              <div className="form-group">
                <label>Description *</label>
                <textarea className="form-control" rows={5} value={form.description} onChange={e=>setForm({...form,description:e.target.value})} placeholder="Compelling book description…" required/>
              </div>
              <div className="form-group">
                <label>Tags (comma separated)</label>
                <input className="form-control" value={form.tags} onChange={e=>setForm({...form,tags:e.target.value})} placeholder="adventure, romance, magic"/>
              </div>
            </div>
          </div>

          <div style={{display:'flex',justifyContent:'flex-end',gap:12,paddingTop:24,borderTop:'1px solid var(--border)',marginTop:16}}>
            <button type="button" className="btn btn-ghost" onClick={()=>navigate('/admin/books')}>Cancel</button>
            <button type="submit" className="btn btn-gold" disabled={busy}>{busy?'Creating…':'Create Book'}</button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
}
